"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventReceivedHistoryMessageSchema = exports.SecretKeyCreatedHistoryMessageSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const history_worker_1 = require("../../history-worker");
const SecretKeyCreatedPayloadSchema = (0, core_1.StrictObject)({
    secretKey: typebox_1.Type.String(),
});
const EventRecievedPayloadSchema = (0, core_1.StrictObject)({
    secretKey: typebox_1.Type.String(),
});
exports.SecretKeyCreatedHistoryMessageSchema = (0, history_worker_1.createHistoryMessageSchema)(ruby_1.HistoryRecordType.ATTRIBUTIONS_SECRET_KEY_CREATED, SecretKeyCreatedPayloadSchema);
exports.EventReceivedHistoryMessageSchema = (0, history_worker_1.createHistoryMessageSchema)(ruby_1.HistoryRecordType.ATTRIBUTIONS_EVENT_RECEIVED, EventRecievedPayloadSchema);
